import React from 'react';
import { Card, CardBody, HStack, Icon, Input, Text, VStack } from '@chakra-ui/react';
import { FiCalendar } from 'react-icons/fi';

const DashboardFilters = ({ dateFrom, setDateFrom, dateTo, setDateTo }) => (
  <Card
    bg="rgba(255, 255, 255, 0.86)"
    borderRadius="18px"
    boxShadow="0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.04)"
    border="1px solid"
    borderColor="rgba(0, 0, 0, 0.06)"
    mb={6}
  >
    <CardBody p={{ base: 4, md: 5 }}>
      <VStack align="stretch" spacing={4}>
        <HStack spacing={2} color="gray.700">
          <Icon as={FiCalendar} w={4} h={4} />
          <Text fontSize="sm" fontWeight="600" letterSpacing="-0.2px">
            Transaction Date Range
          </Text>
        </HStack>
        <HStack spacing={3} flexWrap="wrap">
          <Input
            type="date"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            maxW={{ base: '100%', md: '220px' }}
            bg="white"
            borderColor="rgba(0, 0, 0, 0.12)"
            borderRadius="12px"
            _focusVisible={{ borderColor: '#007AFF', boxShadow: '0 0 0 1px #007AFF' }}
          />
          <Text fontSize="sm" color="gray.500" px={1}>
            to
          </Text>
          <Input
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            maxW={{ base: '100%', md: '220px' }}
            bg="white"
            borderColor="rgba(0, 0, 0, 0.12)"
            borderRadius="12px"
            _focusVisible={{ borderColor: '#007AFF', boxShadow: '0 0 0 1px #007AFF' }}
          />
        </HStack>
      </VStack>
    </CardBody>
  </Card>
);

export default DashboardFilters;
